export default __webpack_public_path__ + "static/media/9.4a4b3e8f.png";